import { forceSmallPortraitLayout } from './forceSmallPortraitLayout';
/**
 * Calculates if real estate is enough to render player in full mode
 * with wings or tiles.
 *
 * Note: This is not about the device display size, but the available area
 * unless we have a really small device (see. `forceSmallPortraitLayout`).
 *
 * @param availableWidth
 * @param availableHeight
 * @returns
 */
export function hasEnoughSpace(availableWidth, availableHeight) {
    return (availableWidth > 500 && availableHeight > 500 && !forceSmallPortraitLayout());
}
